import $ from 'jquery';

import './style.css';
import 'ol-layerswitcher/dist/ol-layerswitcher.css';
import 'ol-ext/dist/ol-ext.css';

import Map from 'ol/Map';
import View from 'ol/View';
import TileLayer from 'ol/layer/Tile';
import LayerTile from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import {Vector as VectorLayer} from 'ol/layer';
import {Vector as VectorSource} from 'ol/source';
import {Control, ScaleLine, OverviewMap, defaults} from 'ol/control';
import {DragRotateAndZoom, defaults as defaultInteractions} from 'ol/interaction';
import WMSGetFeatureInfo from 'ol/format/WMSGetFeatureInfo';

import LayerGroup from 'ol/layer/Group';
import SourceOSM from 'ol/source/OSM';
import XYZ from 'ol/source/XYZ';

import LayerSwitcher from 'ol-layerswitcher';
import {BaseLayerOptions, GroupLayerOptions} from 'ol-layerswitcher';

import Overlay from 'ol/Overlay';

import Feature from 'ol/Feature';
import Geolocation from 'ol/Geolocation';
import Point from 'ol/geom/Point';
import {Circle as CircleStyle, Fill, Stroke, Style, Text, Icon} from 'ol/style';
import ImageStyle from 'ol/style/Image';
import RegularShape from 'ol/style/RegularShape';

import Legend from 'ol-ext/legend/Legend';
import LegendCtrl from 'ol-ext/control/Legend';
import PrintDialog from 'ol-ext/control/PrintDialog';
import CanvasScaleLine from 'ol-ext/control/CanvasScaleLine';
import CanvasTitle from 'ol-ext/control/CanvasTitle';
import Graticule from 'ol/layer/Graticule';
import {saveAs} from 'file-saver';

import axios from 'axios';
import { Buffer } from 'buffer';
import GeoJSON from 'ol/format/GeoJSON';

// Constantes de respaldo
const center = [-74.049660, 4.676819];
const urlbase = window.location.origin + '/geoserver/';
const store = 'CREG';
const lyr = ['CREG:T_CLIENTE_TR_CREG','CREG:MV_LINE_SEGMENT_NOAP'];
const styles = ['CREG:semaforo1','CREG:semaforo2','CREG:TramoBT'];
// Constantes de respaldo

// Constantes
const zoom = 18;
const proj = 'EPSG:4326';
const types = ["wms","wfs"]
const ttl_s = 'Disponibilidad de recursos de generación distribuida (GD) y autogeneración a pequeña escala (AGPE)';
const ttl_f = 'Enel - GD y AGPE'
const loc = document.getElementById('loc');
const slide = document.getElementById('slide');
const container = document.getElementById('popup');
const content = document.getElementById('popup-content');
const closer = document.getElementById('popup-closer');
const tp_f = document.getElementById('tp_f');
const f = document.getElementById('f');
const btn = document.getElementById('btn');
const upd = document.getElementById('upddate');
const tknt = document.getElementById("tkn-true");
const tknf = document.getElementById("tkn-false");
const ldr = document.getElementById("loader");
const urlWMS = urlbase+types[0];
const urlWFS = urlbase+types[1];
// Constantes

// Funciones varias
document.getElementById('ttl').innerHTML += ttl_s;
const Deg2DMS = function(deg, lat) {
    var absolute = Math.abs(deg);
    var degrees = Math.floor(absolute);
    var minutesNotTruncated = (absolute - degrees)*60;
    var minutes = Math.floor(minutesNotTruncated);
    var seconds = ((minutesNotTruncated - minutes)*60).toFixed(2);
    if (lat) {var direction = deg >= 0 ? "N" : "S";}
    else {var direction = deg >= 0 ? "E" : "W"; }
    return degrees + "°" + minutes + "'" + seconds + "\"" + direction;
};
const FechayDia = function(d) {
  var days = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];
  var months = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
  var dia = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
  var hora = d.getUTCHours()<10 ? '0'+d.getUTCHours() : d.getUTCHours();
  var min = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
  var sec = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
  var fecha = days[d.getDay()]+" "+dia+" de "+months[d.getMonth()]+" de "+d.getFullYear()+" a las "+hora+":"+min+":"+sec;
  return(fecha);
};
document.getElementById("f").addEventListener("keypress", function(event) {
  var regex = new RegExp("^[a-zA-Z0-9]+$");
  var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
  if (!regex.test(key)) {
    event.preventDefault();
    return false;
  }
});
document.getElementById("f").addEventListener('paste', function(e) {
  const clipboardData = e.clipboardData || window.clipboardData;
  const pastedText = clipboardData.getData('text');
  const cleanedText = pastedText.replace(/[^a-zA-Z0-9]/g, '');
  e.preventDefault();
  document.execCommand('insertText', false, cleanedText);
});
// Funciones varias

// Autenticación
function validateSession() {
  fetch('/auth/token', {method: 'GET', credentials: 'include'}).then(response => response.json()).then(isValid => processAuth(isValid));
}
function processAuth(isValid) {if (!isValid) {handleInvalidSession(); } }
function handleInvalidSession() {
  tknt?.remove();
  upd?.remove();
  tknf.style.display = "inline";
  window.sessionStorage.clear();
  const redirectAt = Date.now() + 6000;
  const originalText = tknf.innerHTML;
  const interval = setInterval(() => {
    const diff = Math.round((redirectAt - Date.now()) / 1000);
    tknf.innerHTML = `${originalText}<b>${diff} s</b>`;
    if (diff < 1) {
      clearInterval(interval);
      window.location.replace("https://www.enel.com.co/es/AccessMyEnel.html");
    }
  }, 1000);
}
validateSession();
setInterval(() => {validateSession();}, 5*60*1000);
// Autenticación

// Grupos
const getGroup = function(ttl, lyrs){return(new LayerGroup({title: ttl, layers: lyrs})); };
// Grupos

// Capas
const getSRC = function(x){
  const src = new TileWMS({url: urlWMS, params: {'LAYERS': lyr[x[0]], 'TILED': true, 'VERSION': '1.3.0', 'FORMAT': 'image/png', 'STYLES': styles[x[1]]}, serverType: 'geoserver', crossOrigin: 'use-credentials'});
  return(src);
};
const getWMS = function(ttl, x){
  const wms = new LayerTile({title: ttl, type: 'overlay', visible: true, source: getSRC(x)});
  return(wms);
}
const getLyrs = function(){
  const prms = [['Red BT', [1,2]],['Semáforo 2', [0,1]],['Semáforo 1', [0,0]]];
  var lyrs = [];
  for(var i=0; i<prms.length; i++){lyrs.push(getWMS(prms[i][0], prms[i][1]));}
  return lyrs;
}
var lyrs = getGroup('GD y AGPE', getLyrs());
// Capas

// Mapas Base
const bmssrcs = [new SourceOSM(), new XYZ({url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', })];
const getBMs = function(prms){
  var bms = [];
  for(var i=0; i<prms.length; i++){bms.push(new LayerTile({title: prms[i][0], type: 'base', visible: prms[i][1], source: prms[i][2]}));}
  return(bms);
}
var prmsBM = [['Open Street Map', true, bmssrcs[0]],['Satélite', false, bmssrcs[1]]];
var bms = getGroup('Mapas Base', getBMs(prmsBM));
// Mapas Base

// Mapa
const overlay = new Overlay({element: container, autoPan: true, autoPanAnimation: {duration: 250, }, });
closer.onclick = function () {
  overlay.setPosition(undefined);
  closer.blur();
  return false;
};
const view = new View({projection: proj, center: center, zoom: zoom, minZoom:17, maxZoom:19});
const map = new Map({
  interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
  target: 'map',
  layers: [bms, lyrs],
  overlays: [overlay],
  view: view,
  controls: defaults({ "attribution": false }),
});
// Mapa

// Widget de Busqueda
const setUpD = function(){
  const params = {service: 'WFS', version: '2.0.0', request: 'GetFeature', typeNames: lyr[0], outputFormat: 'application/json', count: 1 };
  axios.get(urlWFS, {params: params}).then(response => {getUpD(response.data);}).catch(error => {console.error(error); })
  function getUpD(data){upd.innerHTML = 'Última actualización:<br>'+ FechayDia(new Date(data['features'][0]['properties']['FECHA_ACTUALIZACION'])); }
};
setUpD();
tp_f.onchange = function() {
  switch(document.getElementById('tp_f').value) {
    case 'NRO_CUENTA_CLIENTE': f.placeholder = 'Buscar # Cuenta Cliente...'; break;
    case 'TRANSFORMADOR': f.placeholder = 'Buscar Transformador...'; break;
    default:
  }
};
function searchW() {
  ldr.style.display = 'block';
  var tp_f_v = tp_f.value;
  var f_v = f.value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 10);
  var cqlf = '';
  if(tp_f_v!='NRO_CUENTA_CLIENTE'){cqlf = tp_f_v+" = '"+f_v+"'";} else{cqlf = tp_f_v+" LIKE '%"+f_v+"%'";}
  const params = {service: 'WFS', version: '2.0.0', request: 'GetFeature', typeNames: lyr[0], outputFormat: 'application/json', cql_filter: cqlf };
  axios.get(urlWFS, {params: params}).then(response => {prcsWFSData(response.data);}).catch(error => {srchData(tp_f_v, f_v, 2); ldr.style.display = 'none'; console.error(error);});
  function prcsWFSData(data){
    if(data.features.length>0){
      var f = data['features'][0];
      var coord = f['geometry']['coordinates'];
      view.setCenter(coord);
      map.dispatchEvent({type: 'singleclick', coordinate: coord, });
      var clnt = f['properties']['CANT_CLIENTE_TR'];
      if(clnt==0){srchData(tp_f_v, f_v, 3);}
    } else {srchData(tp_f_v, f_v, 1);}
    ldr.style.display = 'none';
  }
}
btn.addEventListener('click', searchW, true);
// Widget de Busqueda

// Ubicación
map.on('pointermove', function (evt) {var coord = evt.coordinate; loc.innerHTML = Deg2DMS(coord[0]) + "&nbsp;&nbsp;&nbsp;" + Deg2DMS(coord[1],true); });
class setLoc extends Control {
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement('button');
    button.id = 'geoloc';
    button.title = 'Geolocalización';
    button.innerHTML = '<img src="https://img.icons8.com/color/48/000000/near-me--v1.png" style="height:20px;" />';
    const element = document.createElement('div');
    element.className = 'rotate-north ol-unselectable ol-control ol-collapsed';
    element.appendChild(button);
    super({element: element, target: options.target, });
    button.addEventListener('click', this.getLoc.bind(this), false);
  }
  getLoc() {
    const geoloc = new Geolocation({trackingOptions: {enableHighAccuracy: true, }, projection: view.getProjection(), });
    geoloc.setTracking(true);
    const accuracyFeature = new Feature();
    geoloc.on('change:accuracyGeometry', function () {accuracyFeature.setGeometry(geoloc.getAccuracyGeometry()); });
    const positionFeature = new Feature();
    positionFeature.setStyle(new Style({image: new CircleStyle({radius: 6, fill: new Fill({color: '#3399CC', }), stroke: new Stroke({color: '#fff', width: 2, }), }), }) );
    geoloc.on('change:position', function () {const coordinates = geoloc.getPosition(); positionFeature.setGeometry(coordinates ? new Point(coordinates) : null); view.setCenter(coordinates); });
    new VectorLayer({map: map, source: new VectorSource({features: [accuracyFeature, positionFeature], }),});
  }
}
// Ubicación

// Leyenda
var lgnd = new Legend({title:'Leyenda', margin: 25});

const getLegendIcon = async (lyrname, styleName) => {
  try {
    const response = await axios.get(urlWMS, {params: {service: 'WMS', version: '1.3.0', request: 'GetLegendGraphic', layer: lyrname, style: styleName, format: 'image/png', width: 100, height: 10, legend_options: 'fontName:Arial;fontSize:13'}, responseType: 'arraybuffer', });
    const base64Image = Buffer.from(response.data, 'binary').toString('base64');
    const iconDataUri = `data:image/png;base64,${base64Image}`;
    return iconDataUri;
  } catch (error) {console.error('Legend fetch failed', error); }
};

const ix = [[0,0],[0,1],[1,2]];
for (const x in ix) {lgnd.addItem({title:'', typeGeom: 'Point', style: new Style({image: new Icon({src: await getLegendIcon(lyr[ix[x][0]], styles[ix[x][1]])}) }) });}

var lgndctrl = new LegendCtrl({legend: lgnd, collapsed: false, });
var lyrs_l = []
for (var i=0; i<3; i++){lyrs_l.push(lyrs.values_.layers.array_[i])}
var showLgnd = function(i) {lyrs_l[i].on('change:visible', function(){if(!lyrs_l[0].getVisible() && !lyrs_l[1].getVisible() && !lyrs_l[2].getVisible()){lgndctrl.element.style.display = 'none';} else{lgndctrl.element.style.display = '';} }); }
for (var i=0; i<3; i++){showLgnd(i);}
// Leyenda

// Imprimir
PrintDialog.prototype._labels['es'] = {cancel:'Cancelar', copied:'✔ Copiado al portapapeles', custom:'Tamaño de Pantalla', errorMsg:"No se puede guardar el mapa...", legend:'Leyenda', mapTitle:'Título del Mapa', margin:'Márgenes', north:'Flecha de Norte', printBt:'Imprimir...', saveLegend:'Guardar Leyenda', saveas:'Guardar como', scale:'Escala', size:'Tamaño de Página', title: 'Imprimir'};
var prntd = new PrintDialog({lang:'es', title:'Imprimir'});
prntd.setSize('A4');
prntd.setOrientation('landscape');
prntd.setMargin(5);
prntd.on(['print','error'], function(e) {
  if (e.image) {
    if (e.pdf) {
      var pdf = new jspdf.jsPDF({orientation: e.print.orientation, unit: e.print.unit, format: e.print.size });
      pdf.addImage(e.image, 'JPEG', e.print.position[0], e.print.position[0], e.print.imageWidth, e.print.imageHeight);
      pdf.save(e.print.legend ? 'Leyenda.pdf' : ttl_f+'.pdf');
    } else  {
      e.canvas.toBlob(function(blob) {
        var name = (e.print.legend ? 'Leyenda.' : ttl_f)+e.imageType.replace('image/','');
        saveAs(blob, name);
      }, e.imageType, e.quality);
    }
  } else {console.warn('No canvas to export');}
});
prntd.element.childNodes[0].onclick = function(){
  cnvsttl.setVisible(true);
  map.addControl(grat);
  document.getElementsByClassName("ol-ext-buttons")[0].onclick = function(){map.removeControl(grat);};
  document.getElementsByClassName("ol-closebox")[1].onclick = function(){map.removeControl(grat);};
};
// Imprimir

// Escala
// var scale = new ScaleLine({units: "metric", bar: true, steps: 4, text: true, minWidth: 140, });
// scale.element.childNodes[0].style.left = window.innerWidth/2 + "px!important";
// Escala

// Controles
var cnvsttl = new CanvasTitle({title: 'Enel - '+ttl_s, visible: false, style: new Style({ text: new Text({ font: '20px Arial'}) }) });
var cnvscsl = new CanvasScaleLine();
var overvmc = new OverviewMap({layers: [new TileLayer({source: bmssrcs[1],}), ], collapseLabel: '\u00BB', label: '\u00AB', collapsed: false, });
var lyrSwitch = new LayerSwitcher({reverse: true, groupSelectStyle: 'group'});
var geoloc = new setLoc();
var grat = new Graticule({showLabels: true, strokeStyle: new Stroke({color: 'rgba(0,0,0,1)', width: 1, lineDash: [0.5, 4], }),});
var addControls = function(map, ctrls){for(var i=0; i<ctrls.length; i++){map.addControl(ctrls[i]); } }
addControls(map, [overvmc, lyrSwitch, geoloc, lgndctrl, prntd, cnvscsl, cnvsttl, /*scale,*/ ]);
// Controles

// Tooltip
function getDataWMS(html){
  var i1 = html.indexOf('<tr>')
  var i2 = html.indexOf('</table>');
  var s_html = html.substring(i1, i2);  
  var a = s_html.split("<th >");
  var b = s_html.split("<td>");
  var col = [];
  var row = [];
  var txt = "<p style='font: 10px arial;'>";
  var l = [a.length,b.length,parseInt(b.length/a.length)];
  for(var j=0; j<l[2]; j++){for(var i=0; i<a.length; i++){col.push(a[i].split("</th>")[0]);}}
  for(var i=1; i<b.length; i++){
    var x = b[i].split("</td>")[0];
    var x = x != "" ? x : "N/A";
    row.push(x);
  }
  var l = [row.length/l[2],l[2]];
  var d = [];
  for(var j=0; j<l[1]; j++){
    var d0 = {};
    for(var i=l[0]*j; i<l[0]*(j+1); i++){d0[col[i]] = row[i];}
    d[j] = d0;
  }
  var groupBy = function(xs, key) {
    return xs.reduce(function(rv, x) {
      (rv[x[key]] = rv[x[key]] || []).push(x);
      return rv;
    }, {});
  };
  var xy = [Deg2DMS(d[0]['LONGITUD']),Deg2DMS(d[0]['LATITUD'],true)];
  var descrp = d[0]['MUNICIPIO'];
  if(parseInt(d[0]['CANT_CLIENTE_TR'])!=0){descrp = d[0]['COD_CIRCUITO']+' - '+d[0]['NOMBRE_CIRCUITO']+'<br>'+descrp}
  var txt = '<button class="accordion" id="cd"><b>Cabina Secundaria '+d[0]['NOMB_CABINA_SECUNDARIA']+'</b></button><div class="panel" id="tooltip"><p><table id="tb0"><tbody><tr><th colspan="1">Descripción</th><th colspan="2">Voltaje Nominal</th><th colspan="2">Coordenadas planas UTM (Huso '+d[0]['HUSO']+')</th></tr><tr><td rowspan="4"> '+descrp+'</td></tr><tr><th>Trafo (kV)</th><td>'+d[0]['VOLTAJE_NOMINAL_TRAFO']+'</td><td><b>X: </b>'+parseFloat(d[0]['UTM_X']).toFixed(2)+' mts</td><td><b>Y: </b>'+parseFloat(d[0]['UTM_Y']).toFixed(2)+' mts</td></tr><tr><th>S/E (kV)</th><td>'+d[0]['VOLT_NOM_SE']+'</td><th colspan="2">Coordenadas geográficas</th></tr><tr><th>Red BT (kV)</th><td>'+d[0]['VOLTAJE_NOMINAL_REDES_BT']+'</td><td><b>Longitud: </b>'+xy[0]+'<b></td><td><b>Latitud: </b>'+xy[1]+'</td></tr></tbody></table></p></div>';
  var gd = groupBy(d, 'TRANSFORMADOR');
  var clnt_trf = {};
  for(var i=0; i<l[1]; i++){clnt_trf[d[i]['TRANSFORMADOR']] = d[i]['CANT_CLIENTE_TR'];}
  clnt_trf = Object.entries(clnt_trf);
  var ccf = '';
  var cto = '';
  for(var x=0; x<clnt_trf.length; x++){
    var trf = clnt_trf[x][0];
    var clnt = parseInt(clnt_trf[x][1]);
    var d = gd[trf];
    for(var i=0; i<d.length; i++){
      var capd = d[i]['CAPACIDAD_DISPONIBLE'];
      var capt = d[i]['CAPACIDAD_TRAFO'];
      var cmeh = d[i]['CANT_MIN_ENERGIA_HR'];
      var spm = d[i]['SUM_POTENCIA_MAX'];
      var pahm = d[i]['PROM_ANUAL_HRS_MIN'];
      var sce = d[i]['SUM_CANTIDAD_ENERGIA'];
      var cc = d[i]['COD_CIRCUITO'];
      var nc = d[i]['NOMBRE_CIRCUITO'];
      var trfc = clnt==1 ? trf+' ('+clnt+' cliente conectado)' : trf+' ('+clnt+' clientes conectados)'
      var sem = [parseFloat(d[i]['SEMAFORO_1']), parseFloat(d[i]['SEMAFORO_2'])]
      var sem1 = sem[0] != 0 ? sem[0].toFixed(0) : sem[0];
      var sem2 = sem[1] != 0 ? sem[1].toFixed(0) : sem[1];
      if(clnt==0){cto += cc+' - '+nc + '<br>';}
    }
    if(cto!=''){
      ccf = '<th>Circuitos en la Frontera</th>';
      cto = '<td rowspan="2">'+cto+'</td>';
    }
    txt += '<button class="accordion" id="trf'+(i+1)+'"><b>Transformador '+trfc+'</b></button><div class="panel" id="tooltip"><p><table id="tb'+(x+1)+'"><tbody><tr><th colspan="2">Capacidad</th><th colspan="2">Energía Horaria</th><th colspan="2">Sumatoria para GD o AGPE</th>'+ccf+'</tr><tr><th>Trafo (kW)</th><td>'+capt+'</td><th>Cantidad Mínima (kW)</th><td>'+cmeh+'</td><th>Potencia Máxima Declarada (kW)</th><td>'+spm+' ('+sem1+'%)</td>'+cto+'</tr><tr><th>Disponible (kW)</th><td>'+capd+'</td><th>Promedio anual para el año anterior (kWh)</th><td>'+pahm+'</td><th>Cantidad Energía Disponible (kW)</th><td>'+sce+' ('+sem2+'%)</td></tr></tbody></table></p></div>';
    ccf = '';
    cto = '';
  }
  return(txt);
}
function checkSmfr(tbid, n, s){
  var c = []
  var s = parseInt(s.split('(')[1].split(' %')[0]);;
  if(s>=0 && s<=30){c = ["green","white"]}
  else if(s>30 && s<=40){c = ["yellow","black"]}
  else if(s>40 && s<=50){c = ["orange","black"]}
  else{c = ["red","white"]}
  var tbr = document.getElementById(tbid).rows[n[0]];
  tbr.cells[n[1]].style.backgroundColor = c[0];
  tbr.cells[n[2]].style.backgroundColor = c[0];
  tbr.cells[n[1]].style.color = c[1];
  tbr.cells[n[2]].style.color = c[1];
  tbr.cells[n[2]].style.width = "70px";
}
map.on('singleclick', function (evt) {
  const coord = evt.coordinate;
  const viewRes = (view.getResolution());
  const url = getSRC([0,0,0]).getFeatureInfoUrl(evt.coordinate, viewRes, 'EPSG:4326', {'INFO_FORMAT': 'text/html', 'FEATURE_COUNT': '1'});
  if (url) {fetch(url).then((response) => response.text()).then((html) => {
    if(html.split('<table class="featureInfo">').length>1){
      content.innerHTML = getDataWMS(html);
      var tb = document.getElementsByTagName("table");
      for(var i=1; i<=tb.length; i++){
        if(tb[i]!=null){
          var c1 = tb[i].rows[1].cells;
          var c2 = tb[i].rows[2].cells;
          if(c1.length>=5){
            var s1 = c1[5].innerHTML;
            var s2 = c2[5].innerHTML;
            checkSmfr("tb"+i, [1,4,5], s1);
            checkSmfr("tb"+i, [2,4,5], s2);
          }
        }
      }
      var acc = document.getElementsByClassName("accordion");
      for (var i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function() {
          this.classList.toggle("active");
          var panel = this.nextElementSibling;
          if (panel.style.maxHeight) {panel.style.maxHeight = null; } else {panel.style.maxHeight = panel.scrollHeight + "px"; }
        });
      }
      overlay.setPosition(coord);
      document.getElementById("cd").click();
    }
  });}
});
// Tooltip